import { useContext, Fragment } from "react";
import { Grid } from "@mui/material";
import moment from "moment";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useTranslation } from "react-i18next";

//import utils
import { formatPersianDate } from "../../../../utils/date";
import { millisecondsToHoursAndMinutes } from "../../../../utils/time";
import { flightDataMapper } from "../../../../utils/flightDataMapper";

//import general components
import TicketArrow from "../../../common/ticket-arrow/ticket-arrow";

//import image
import AirplaneSvg from "../../../../assets/icons/airplane.svg";

export function FlightItemDetails({ flightItem, details, title }) {
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    const domesticFlightInformation = JSON.parse(sessionStorage.getItem("domesticFlightInformation"));

    const isTwoWay = domesticFlightInformation?.returnDate;

    const normalizedFlight = flightDataMapper(isTwoWay, flightItem, details);

    //list of label's flight
    const LABElS = [
        { id: 1, name: "type", englishName: "persianType" },
        { id: 2, name: "flightNumber", englishName: "flightNumber" },
        { id: 3, name: "cabinPersian", englishName: "cabin" },
        { id: 4, name: "aircraft", englishName: "aircraft" },
    ];

    return (
        <>
            <Grid container item xs={12} rowGap={1} columnGap={{ xs: 0.5, md: 1 }} alignItems="center">
                {!!isTwoWay && (
                    <Grid className="flight-item__title" container item xs="auto">
                        <span>{title}</span>
                    </Grid>
                )}
                {LABElS.map(item => {
                    return (
                        <Fragment key={item?.id}>
                            {normalizedFlight?.[item.name] && (
                                <Grid
                                    component="span"
                                    className="flight-item__label"
                                    container
                                    item
                                    xs="auto"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    {locale === "en" ? normalizedFlight[item.name] || "" : normalizedFlight[item.englishName] || ""}
                                </Grid>
                            )}
                        </Fragment>
                    );
                })}

                {flightItem?.sellingType === "Only Iranian" || flightItem?.sellingType === "Non Iranian" ? (
                    <Grid className="flight-item__label" component="span" container item xs="auto" justifyContent="center" alignItems="center">
                        {flightItem?.sellingType === "Only Iranian" ? t("onlyIranian") : t("nonIranian")}
                    </Grid>
                ) : null}
            </Grid>
            <Grid container item xs={12} justifyContent="space-between" alignItems={{ xs: "center", md: "flex-start" }}>
                <Grid container item xs={3.5} md={5} rowGap={1} alignItems={{ xs: "center", lg: "flex-start" }}>
                    <Grid container item xs={12} md={3} justifyContent={{ xs: "center", md: "flex-start" }}>
                        <img className="flight-item__airline-logo" src={normalizedFlight?.airlineLogo} alt={normalizedFlight?.airline} />
                    </Grid>
                    <Grid container item xs={12} md={8}>
                        <Grid className="flight-item__airline-name" container item xs={12} justifyContent={{ xs: "center", md: "flex-start" }}>
                            {locale === "en"
                                ? normalizedFlight?.airline || " " + ` ${t("airline")}`
                                : `${t("airline")} ` + normalizedFlight?.airlinePersian || ""}
                        </Grid>

                        <span className="flight-item__departure-date">
                            {locale === "en"
                                ? moment(normalizedFlight?.departureDate).format("D MMM")
                                : formatPersianDate(normalizedFlight?.departureDate, {
                                      day: "numeric",
                                      month: "long",
                                      year: undefined,
                                      weekday: "long",
                                  })}
                        </span>
                    </Grid>
                </Grid>

                <Grid container item xs={8.5} md={7} justifyContent="space-around">
                    <Grid container item xs={2} direction="column" rowGap={0.5} justifyContent="center" alignItems="center">
                        <span className="flight-item__city-name">
                            {locale === "en" ? normalizedFlight?.departureEnName || "" : normalizedFlight?.departureFaName || ""}
                        </span>
                        <span className="flight-item__iata">{normalizedFlight?.departureIata || ""}</span>
                        <span className="flight-item__time">{normalizedFlight?.departureTime?.split(":", 2).join(":") || ""}</span>
                    </Grid>

                    <Grid container item xs={6} direction="column" justifyContent="center" alignItems="center">
                        {!!normalizedFlight?.destinationTime && (
                            <span className="flight-item__arrival-time">
                                {millisecondsToHoursAndMinutes(
                                    new Date(normalizedFlight?.arrivalDate + "T" + normalizedFlight?.destinationTime).getTime() -
                                        new Date(normalizedFlight?.departureDate + "T" + normalizedFlight?.departureTime).getTime(),
                                )}{" "}
                                {t("hours")}
                            </span>
                        )}
                        <TicketArrow icon={<img src={AirplaneSvg} />} />
                    </Grid>

                    <Grid container item xs={2} direction="column" justifyContent="center" alignItems="center" rowGap={0.5}>
                        <span className="flight-item__city-name">
                            {locale === "en" ? normalizedFlight?.destinationEnName || "" : normalizedFlight?.destinationFaName || ""}
                        </span>
                        <span className="flight-item__iata">{normalizedFlight?.destinationIata || ""}</span>
                        <span className="flight-item__time">{normalizedFlight?.destinationTime?.split(":", 2).join(":") || ""}</span>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
